var QuestionTypes = require("lib/academic/QuestionTypes");
var TextTypes = require("lib/academic/TextTypes");

// Filters are directly applied as key value to query
// Conditions are transformed in different ways depending on the key
export function toQuery(filters, conditions) {
	var query = _.clone(filters || {});

	if (!_.isEmpty(conditions)) {
		if (conditions.userIDs && (conditions.userIDs.length > 0)) {
			query.user_ids = conditions.userIDs.join(",")
		}

		if (conditions.userID) {
			query.user_id = conditions.userID;
		}

		if (conditions.studentListIDs && (conditions.studentListIDs.length > 0)) {
			query.student_list_ids = conditions.studentListIDs.join(",")
		}

		if (conditions.studentListID) {
			query.student_list_id = conditions.studentListID;
		}

		if (conditions.textVariety && (conditions.textVariety != TextTypes.Varieties.BOTH)) {
			query.text_variety = conditions.textVariety
		}
		if (conditions.startDate)	{ query.start_date = conditions.startDate }
		if (conditions.endDate)		{ query.end_date = conditions.endDate }
		if (conditions.textID)		{ query.text_id = conditions.textID }
		if (conditions.status) 		{ query.status = conditions.status }

		if (conditions.sample)		{ query.sample = conditions.sample }
		if (conditions.order)		{ query.order_by = conditions.order }
		if (conditions.perPage)		{ query.per_page = conditions.perPage }
		if (conditions.withTotal) 	{ query.with_total = conditions.withTotal }
		if (conditions.noPagination) { query.no_pagination = conditions.noPagination }
		if (conditions.slIDs) { query.sl_ids = conditions.slIDs.join(',') }
		if (conditions.adminID) { query.id = conditions.adminID }
		if (conditions.entityType) { query.entity_type = conditions.entityType }
		if (conditions.entityID) { query.entity_id = conditions.entityID }
		if (conditions.period) { query.period = conditions.period }
		if (conditions.archived) { query.archived = conditions.archived }
		if (conditions.key) { query.key = conditions.key }
		if (conditions.readBook) { query.read_book = conditions.readBook }
		if (conditions.digestSummary) {query.digest_summary = conditions.digestSummary}
		if (conditions.graphDigestsOnly) {query.graph_digests_only = conditions.graphDigestsOnly}
		if (conditions.name) { query.name = conditions.name }
		if (conditions.page) { query.page = conditions.page }
		if (conditions.nameExact) { query.name_exact = conditions.nameExact }
		if (conditions.orgAdminID) { query.org_admin_id = conditions.orgAdminID }
		if (conditions.orgID) { query.org_id = conditions.orgID }

		if (conditions.allowDraft) {
			query.draft = true;
		} else if (conditions.draftOnly) {
			query.draft = "only";
		} else if (conditions.draft !== undefined) {
			query.draft = conditions.draft
		}

		if (conditions.oneOfMatch) {
			_.each(conditions.oneOfMatch, (values, key) => {
				query[key] = values.join(",");
			});
		}
	}

	return query;
}

export function nonQuizAnswerQuery(baseQuery) {
	return _.extend({}, baseQuery, {
		for_quiz: false,
		question_types: QuestionTypes.PRACTICE_QUESTION_TYPES.join(",")
	})
}

export function metaCogAnswerQuery(baseQuery) {
	return _.extend({}, baseQuery, {
		question_types: QuestionTypes.META_COGNITIVE_QUESTION
	})
}

export function reviewQuery(baseQuery) {
	return _.extend({}, baseQuery, {
		question_types: QuestionTypes.REVIEW_QUESTION
	})
}

export function essayAnswerQuery(baseQuery) {
	return _.extend({}, baseQuery, {
		question_types: QuestionTypes.ESSAY_QUESTION
	})
}



// WEBPACK FOOTER //
// ./modules/lib/shared/Queries.js